/**
 * Whether an hour has begun. Ruled 12 October: from then on a lesson cannot be
 * cancelled, by the family or the coach — the coach closes it instead.
 *
 * The screens use this to stop offering Cancel. It is not the rule: the API
 * checks against the database's clock and refuses, whatever this phone thinks
 * the time is.
 */
export function hasStarted(slotStart: string, now: Date = new Date()): boolean {
  return new Date(slotStart).getTime() <= now.getTime();
}
